// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "auth." + ({"282":"page-help","382":"page-profile","649":"page-not-found"}[chunkId] || chunkId) + "." + {"139":"b3c6c1f19ca62cb2d7d7","282":"4b2c7d4f6f352742e8e0","382":"b11e8d9ef750b0bf12f6","603":"e375aac55242a3a1077b","649":"4e68bac36cf76a0e01d9"}[chunkId] + ".js";
};